import { Injectable, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private oidcSecurityService = inject(OidcSecurityService);

  /**
   * ตรวจสอบว่าผู้ใช้มี role ที่ระบุใน qrtraces หรือไม่
   * @param role role ที่ต้องการตรวจสอบ
   * @returns Observable<boolean> ผลการตรวจสอบ
   */
  hasRole(role: string): Observable<boolean> {
    return this.oidcSecurityService.getPayloadFromAccessToken().pipe(
      map(payload => this.checkRoleInPayload(payload, role))
    );
  }

  /**
   * ตรวจสอบว่าผู้ใช้มี role ที่ระบุใน qrtraces อย่างน้อยหนึ่ง role หรือไม่
   * @param roles array ของ role ที่ต้องการตรวจสอบ
   * @returns Observable<boolean> ผลการตรวจสอบ
   */
  hasAnyRole(roles: string[]): Observable<boolean> {
    return this.oidcSecurityService.getPayloadFromAccessToken().pipe(
      map(payload => {
        for (const role of roles) {
          if (this.checkRoleInPayload(payload, role)) {
            return true;
          }
        }
        return false;
      })
    );
  }

  /**
   * ตรวจสอบว่าผู้ใช้มีทุก role ที่ระบุใน qrtraces หรือไม่
   * @param roles array ของ role ที่ต้องการตรวจสอบ
   * @returns Observable<boolean> ผลการตรวจสอบ
   */
  hasAllRoles(roles: string[]): Observable<boolean> {
    return this.oidcSecurityService.getPayloadFromAccessToken().pipe(
      map(payload => {
        for (const role of roles) {
          if (!this.checkRoleInPayload(payload, role)) {
            return false;
          }
        }
        return true;
      })
    );
  }

  /**
   * ดึงรายการ roles ทั้งหมดของผู้ใช้จาก qrtraces
   * @returns Observable<string[]> รายการ roles
   */
  getUserRoles(): Observable<string[]> {
    return this.oidcSecurityService.getPayloadFromAccessToken().pipe(
      map(payload => {
        if (payload && payload.resource_access) {
          const qrtracesAccess = payload.resource_access['qrtraces'];
          if (qrtracesAccess && qrtracesAccess.roles) {
            return qrtracesAccess.roles;
          }
        }
        return [];
      })
    );
  }

  /**
   * ตรวจสอบ role ใน payload
   * @param payload payload จาก token
   * @param role role ที่ต้องการตรวจสอบ
   * @returns boolean ผลการตรวจสอบ
   */
  private checkRoleInPayload(payload: any, role: string): boolean {
    if (payload && payload.resource_access) {
      const qrtracesAccess = payload.resource_access['qrtraces'];
      if (qrtracesAccess && qrtracesAccess.roles) {
        return qrtracesAccess.roles.includes(role);
      }
    }
    return false;
  }
}
